import * as React from 'react';
import { easeIn, getMask } from './helpers';
import * as styles from './ScrollFade.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var ScrollFade = function ScrollFade(_ref) {
  var size = _ref.size;
  var rootRef = React.useRef(null);
  var onScroll = React.useCallback(function () {
    var _rootRef$current;

    var scrollElement = (_rootRef$current = rootRef.current) === null || _rootRef$current === void 0 ? void 0 : _rootRef$current.parentElement;

    if (scrollElement) {
      var offsetHeight = scrollElement.offsetHeight,
          scrollHeight = scrollElement.scrollHeight,
          scrollTop = scrollElement.scrollTop;
      var opacityTop = easeIn((scrollHeight - offsetHeight - scrollTop) / (offsetHeight - scrollHeight), 10);
      var opacityBottom = easeIn(scrollTop / (offsetHeight - scrollHeight), 10);
      var mask = getMask({
        size: size,
        opacityTop: opacityTop,
        opacityBottom: opacityBottom
      });
      scrollElement.style.mask = mask;
      scrollElement.style.webkitMask = mask;
    }
  }, [size]);
  React.useEffect(function () {
    var _rootRef$current2;

    var scrollElement = (_rootRef$current2 = rootRef.current) === null || _rootRef$current2 === void 0 ? void 0 : _rootRef$current2.parentElement;

    if (!scrollElement) {
      return;
    }

    var offsetHeight = scrollElement.offsetHeight,
        scrollHeight = scrollElement.scrollHeight;

    if (offsetHeight !== scrollHeight) {
      var mask = getMask({
        size: size,
        opacityTop: 1,
        opacityBottom: 0
      });
      scrollElement.style.mask = mask;
      scrollElement.style.webkitMask = mask;
    }

    scrollElement.addEventListener('scroll', onScroll, {
      passive: true
    });
    return function () {
      return scrollElement.removeEventListener('scroll', onScroll);
    };
  }, [onScroll, size]);
  return /*#__PURE__*/_jsx("span", {
    ref: rootRef,
    className: styles['container']
  });
};